import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link as RouteLink, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectAuthState } from 'app/store/selectors'
import { RouteUrl } from 'app/routes'
import { AuthenticationButtons } from 'app/features/home/components/authenticationButtons'
import { Logo } from '@tuhi/components'

const Container = styled.div`
    display: flex;
    justify-content: space-between; /* This aligns the buttons and header */
    height: 90px;

    align-items: center;
    padding: 0 120px;
    background-color: ${(p) => p.theme.colors.white};
`

export const Link = styled(RouteLink)`
    text-decoration: none;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    overflow-y: hidden;
    margin-right: 8px;

    &:hover {
        color: ${(p) => p.theme.colors.primaryGreen};
    }
`

export const UnauthenticatedHeader: FC = () => {
    useSelector(selectAuthState)
    const [isAuthenticationRoutes, setIsAuthenticationRoutes] = useState(false)
    const { pathname } = useLocation()

    useEffect(() => {
        setIsAuthenticationRoutes(
            RouteUrl.LogIn.match(pathname) || RouteUrl.SignUp.match(pathname)
        )
    }, [pathname])

    return (
        <Container>
            <Link to={RouteUrl.Home.path}>
                <Logo />
            </Link>

            {!isAuthenticationRoutes && <AuthenticationButtons />}
        </Container>
    )
}
